// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Egz7","title":"styles_title__3lbPE"};